import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBasicDetails } from "../../../../interface/interfaces";

interface IInitialState {
    isDragging: boolean;
    dragNode: IBasicDetails | undefined;
    overNode: IBasicDetails | undefined;
    overTempNodeId: string;
}


const initialState: IInitialState = {
    isDragging: false,
    dragNode: undefined,
    overNode: undefined,
    overTempNodeId: ''
};

const dashboardDragAndDropSlice = createSlice({
    name: "dashboardDragAndDrop",
    initialState,
    reducers: {
        setDragging: (state:IInitialState, action: PayloadAction<{dragging: boolean, dragNode: IBasicDetails, overNode?: IBasicDetails | undefined}>) => {
            state.isDragging = action.payload.dragging;
            state.dragNode = action.payload.dragNode;
            state.overNode = action.payload.overNode;

        },
        
        clearDragging:(state:IInitialState) => {
            state.isDragging = false;
            state.dragNode = undefined;
            state.overNode = undefined;
        },
        
        setOverTempNodeId: (state:IInitialState, action: PayloadAction<string>) => {
            state.overTempNodeId = action.payload;
        },
        clearOverTempNodeId:(state:IInitialState) => {
            state.overTempNodeId = '';
        }
    },
});

export default dashboardDragAndDropSlice.reducer;
export const { setDragging, clearDragging, setOverTempNodeId, clearOverTempNodeId } = dashboardDragAndDropSlice.actions;